import type { FluxZapCommunicationRecord } from "../types";
import { parseFluxZapRecipientReference } from "./fluxZapRecipientReference";

/**
 * Ids que já receberam comunicação, incluindo clientes cadastrados.
 *
 * `buildCommunicatedPatientIdSet` só entende `Patient/{id}`. Ela continua
 * igual para os fluxos antigos; este helper é usado só quando o dialog
 * oferece o público de Person.
 *
 * Os ids ficam sem o tipo (`{id}`), porque `applyPatientFinderFilters`
 * compara pelo `patientId` do resumo — e o resumo de Person guarda o id
 * do Person nesse campo.
 */
export function buildCommunicatedRecipientIdSet(
  communications: FluxZapCommunicationRecord[],
): Set<string> {
  const out = new Set<string>();
  for (const c of communications) {
    const parsed = parseFluxZapRecipientReference(c.subjectPatientReference);
    if (parsed) out.add(parsed.id);
  }
  return out;
}
